// extracted by mini-css-extract-plugin
export default {"statusBar":"Status_statusBar__TQt7X","body":"Status_body__6laDG","progress":"Status_progress__1+qd4","percent":"Status_percent__NQOHx","arrow":"Status_arrow__Xl1XH"};